<template>
  <v-container class="relative mb-8">
    <app-spinner v-if="loading" class="mt-4" />

    <div v-else-if="!proof" class="ma-auto">
      <v-container>
        <v-row align="center" justify="center" class="mt-4 mb-2">
          <v-col cols="11" class="py-0">
            <h1 class="text-h5 text-center">Whoops! That offer is no longer available.</h1>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div v-else class="ma-auto">
      <v-row align="center" justify="center" class="mt-4 mb-2">
        <v-col cols="11" class="py-0 text-center">
          <div class="text-h5 font-weight-light">
            <v-icon color="#00BF16" class="mt-n1">mdi-check-circle-outline</v-icon>
            Submitted Post or Review
          </div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4 mb-2">
        <v-col cols="11" class="py-0">
          <v-img :src="proof.proof_image_url" eager contain width="100%" max-height="300" />
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4 mb-2">
        <v-col cols="11" class="py-0 text-center">
          <div class="body font-weight-light">This customer has unlocked the below offer by submitting this social post or review</div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-6 mb-2">
        <v-col cols="11" class="py-0">
          <div class="instructions-header">EMPLOYEE INSTRUCTIONS:</div>
          <div class="instructions-content">
            1. Press the "Mark as Used" button <br />
            2. Not valid w/ other offers or promotions
          </div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-6 mb-2">
        <v-col cols="11" class="pa-0">
          <LfVoucherTicket
            :business-logo-url="reverseFlowDeal.business.logo_url"
            :business-brand="reverseFlowDeal.business.brand"
            :address="reverseFlowDeal.address"
            :ticket-summary="reverseFlowDeal.offer_summary"
            :redeeming="redeeming"
            :date-redeemed="proof.date_redeemed"
            @activate-voucher-clicked="redeem()"
          />
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-8 mb-2">
        <v-col cols="11" class="py-0">
          <div class="text-h5 font-weight-bold">How to use this voucher</div>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4">
        <v-col cols="1" class="py-0">
          <v-avatar color="primary" size="40" class="mt-n3 mr-3">
            <span class="white--text font-weight-bold">1</span>
          </v-avatar>
        </v-col>
        <v-col cols="10" class="pl-8">
          <span class="text-left section-header">Show your submitted screenshot to the employee</span>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4 mb-2">
        <v-col cols="11" class="py-0 font-weight-light">
          <v-img :src="require(`@/assets/reverseFlow/step_01.svg`)" contain height="250" />
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-8">
        <v-col cols="1" class="py-0">
          <v-avatar color="primary" size="40" class="mt-n3 mr-3">
            <span class="white--text font-weight-bold">2</span>
          </v-avatar>
        </v-col>
        <v-col cols="10" class="pl-7">
          <span class="text-left section-header">The employee will have you press the above "Mark as used" button</span>
        </v-col>
      </v-row>

      <v-row align="center" justify="center" class="mt-4">
        <v-col cols="11" class="py-0 font-weight-light">
          <v-img :src="require(`@/assets/reverseFlow/step_04.jpg`)" max-width="300" class="mx-auto" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '@/services'

import { LfVoucherTicket } from 'lf-common'

export default Vue.extend({
  name: 'VoucherSwayOffer',

  components: {
    LfVoucherTicket,
  },

  metaInfo() {
    return this.reverseFlowDeal
      ? {
          title: `${this.reverseFlowDeal.offer_summary} | ${this.reverseFlowDeal.business.brand}`,
        }
      : {
          title: 'Localfluence',
        }
  },

  props: {
    swayOfferProofId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: true,
    redeeming: false,
    proof: null,
    reverseFlowDeal: null,
  }),

  mounted: function () {
    ApiService.get(`reverseFlow/proof/${this.swayOfferProofId}`).then((response) => {
      this.proof = response.data.reverseFlowProof
      this.reverseFlowDeal = response.data.reverseFlowDeal
      this.loading = false
    })
  },

  methods: {
    redeem() {
      if (this.redeeming) return

      this.redeeming = true

      ApiService.put(`reverseFlow/proof/markAsUsed/${this.swayOfferProofId}`, {}).then((response) => {
        if (response.data.error) {
          this.redeeming = false
          this.$toast.error(response.data.error)

          return
        }

        this.redeeming = false
        this.proof = response.data.reverseFlowProof

        this.$toast.success('Offer redeemed!')
      })
    },
  },
})
</script>

<style scoped>
.instructions-header {
  margin-bottom: 8px;
  color: #ed1e56;
  font-size: 17px;
  font-weight: 700;
}

.instructions-content {
  font-size: 16px;
  font-weight: 700;
}
</style>
